import { useNavigate } from 'react-router-dom'

import IconBtnVert from '@App/components/IconBtnVert/IconBtnVert'

import './mission-setup-tabs.styl'

function MissionSetupTabs() {
  const navigate = useNavigate()

  return (
    <div className="mission-setup-tabs">
      <div className="mission-setup-tabs__tab">
        <IconBtnVert
          iconProps={{ icon: '/img/icons/nav/tent.svg', size: '21px' }}
          inactive={window.location.pathname !== '/mission-setup/environment'}
          onClick={() => navigate('/mission-setup/environment')}
        >
          Environment
        </IconBtnVert>
      </div>
      <div className="mission-setup-tabs__tab">
        <IconBtnVert
          iconProps={{ icon: '/img/icons/nav/trap-planner.svg', size: '21px' }}
          inactive={window.location.pathname !== '/mission-setup/trap-planner'}
          onClick={() => navigate('/mission-setup/trap-planner')}
        >
          Trap planner
        </IconBtnVert>
      </div>
      <div className="mission-setup-tabs__tab">
        <IconBtnVert
          iconProps={{ icon: '/img/icons/nav/waterpond.svg', size: '27px' }}
          inactive={window.location.pathname !== '/mission-setup/breeding-sites'}
          onClick={() => navigate('/mission-setup/breeding-sites')}
        >
          Breeding sites
        </IconBtnVert>
      </div>
    </div>
  )
}

export default MissionSetupTabs
